module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.292b2f8e.ttf";